/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {IAppStore} from 'store';

export const USER_UPDATE = 'USER_UPDATE' as const;
export const USER_LOGOUT = 'USER_LOGOUT' as const;

export const userSelector = ({user}: IAppStore): IAppStore['user'] => user;

interface IUpdateUser {
  type: typeof USER_UPDATE;
  applicationId: string;
}
export const updateUser = (applicationId: string): IUpdateUser => ({
  type: USER_UPDATE,
  applicationId
});

export interface ILogoutUser {
  type: typeof USER_LOGOUT;
}
export const logoutUser = (): ILogoutUser => ({type: USER_LOGOUT});

export type UserActions =
  | IUpdateUser
  | ILogoutUser;